/** @format */

import { useCallback, useState } from "react";

export const useFileUpload = (
  setFileHandler: (file: File | null) => void,
  // maxFileSize in MB
  maxFileSize = 1,
  fileType: string,
  extensions: string[]
) => {
  const [isDropActive, setIsDropActive] = useState(false);
  const [isFileTooBig, setIsFileTooBig] = useState(false);
  const [isFileNotSupported, setIsFileNotSupported] = useState(false);

  // Create handler for dropzone's onDragStateChange:
  const onDragStateChange = useCallback((dragActive: boolean) => {
    setIsDropActive(dragActive);
  }, []);

  // Create handler for dropzone's onFilesDrop:
  const onFileDrop = useCallback(
    (file: File) => {
      if (fileType === "image") {
        if (!extensions.some((ext) => file.name.includes(ext))) {
          setIsFileNotSupported(true);
          return;
        }
      }
      if (!file.type.includes(fileType)) {
        setIsFileNotSupported(true);
        return;
      } else {
        setIsFileNotSupported(false);
      }

      if (file.size > maxFileSize * 1024 * 1024) {
        setIsFileTooBig(true);
        return;
      } else {
        setIsFileTooBig(false);
      }

      setFileHandler(file);
    },
    [maxFileSize, setFileHandler, fileType, extensions]
  );

  return {
    onDragStateChange,
    onFileDrop,
    setIsDropActive,
    isDropActive,
    isFileTooBig,
    isFileNotSupported,
  };
};
